import cn from 'classnames'
import { PropsWithChildren } from 'react'

import styles from './RenderWhen.module.scss'

export interface IRenderWhenProps extends PropsWithChildren {
  condition?: boolean
  keepMounted?: boolean
}

/**
 * Conditionally renders children based on the condition prop
 * @param {IRenderWhenProps} { condition, children, keepMounted }
 * @returns
 */
export const RenderWhen = ({ condition, children, keepMounted }: IRenderWhenProps) => {
  if (keepMounted) {
    return <div className={cn({ [styles.hidden]: !condition })}>{children}</div>
  }

  if (condition) {
    return <>{children}</>
  }

  return null
}

RenderWhen.displayName = 'RenderWhen'
